import Types from '../../types';

const initialState = {
  error: null,
  loading: false,
  requiresRecaptcha: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.REGISTER_EMAIL_ALREADY_TAKEN: {
      return {
        ...state,
        error: { type: Types.REGISTER_EMAIL_ALREADY_TAKEN },
        loading: false,
      };
    }
    case Types.REGISTER_PASSWORD_ERROR: {
      return {
        ...state,
        error: { type: Types.REGISTER_PASSWORD_ERROR },
        loading: false,
      };
    }

    case Types.REGISTER_COGNITO_ERROR: {
      return {
        ...state,
        error: { type: Types.REGISTER_COGNITO_ERROR },
        loading: false,
      };
    }

    case Types.REGISTER_SUBMIT: {
      return {
        ...state,
        loading: true,
      };
    }

    case Types.RECAPTCHA_REQUIRED: {
      return {
        ...state,
        requiresRecaptcha: true,
      };
    }

    case Types.RECAPTCHA_ERROR: {
      return {
        ...state,
        error: { type: Types.RECAPTCHA_ERROR },
        loading: false,
      };
    }

    default:
      return {
        ...state,
      };
  }
};
